module.exports = __webpack_public_path__ + "static/09-827bb00bcdd8a38bc507b165a86381ae.jpg";